import styled from 'styled-components'

export const Wrapper = styled.div`
  max-height: 188px;
  overflow-y: scroll;
  margin-bottom: 16px;
`
